import React from 'react';
import { Container, Button } from "react-bootstrap";
import LandingPageLayout from './components/landing-page-layout';
import { Link } from "react-router-dom";

function LandingPage(): JSX.Element {
    return (
        <LandingPageLayout>
            <Container>
                <div className='text-center mt-5 pt-5'>
                    <h1 className='display-3 fw-bold'>
                        All-in-One Business <br /> Management Software for <br /> Construction Teams
                    </h1>
                    <p className='my-3'>
                        Stay on top of projects, budgets, and teams — all in one place. <br /> Our platform simplifies operations so you can focus on what matters most: <br /> delivering quality work on time and on budget.
                    </p>
                    <div>
                        <Link to="/sign-up" className='link-styles text-white'>
                            <Button type='submit' className='bg-color-1 px-5 py-3 border-0 btn-1'>
                                Get started
                            </Button>
                        </Link>
                    </div>
                </div>
            </Container>
        </LandingPageLayout>
    );
}

export default LandingPage;
